import { DatePicker } from 'module/ui/components/atoms/date-picker';
import { Menu } from 'module/ui/components/atoms/dropdown';
import { Radio } from 'module/ui/components/atoms/radio';
import { snakeCase } from 'lodash';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { Lines, Line } from './components';
import {
  DateFieldFilterOperationType,
  DateFieldFilter,
  DateFieldAbsoluteFilter,
} from '../../../../../../types/filter-field/filter/date';

export const renderAbsoluteMenuItem = (
  filter: DateFieldFilter,
  type: DateFieldFilterOperationType,
  onChange: (filter: DateFieldFilter) => void,
  getOperationOptionRenderer?: (
    type: DateFieldFilterOperationType,
    filter?: DateFieldFilter,
  ) => null | React.JSX.Element,
) => (
  <Menu.Item
    data-cy={`op.${type}`}
    key={type.toString()}
    className="date-criteria"
  >
    <Lines>
      <Line>
        <Radio checked={filter.type === type} />{' '}
        {getOperationOptionRenderer?.(type) ?? (
          <FormattedMessage
            id={`task_list.filters.${snakeCase(
              DateFieldFilterOperationType[type],
            )}`}
          />
        )}
      </Line>
      {filter.type === type && (
        <Line>
          <DatePicker
            data-cy="criteria.abs_op.date_picker"
            autoFocus
            value={(filter as DateFieldAbsoluteFilter).value}
            onChange={(latest) =>
              onChange({
                ...filter,
                value:
                  latest == null
                    ? null
                    : moment.utc(`${latest.format('YYYY-MM-DD')}T00:00:00Z`),
              } as DateFieldFilter)
            }
            allowClear={false}
          />
        </Line>
      )}
    </Lines>
  </Menu.Item>
);
